import {DLMSiteApplicationsListFilter} from './DLMSiteApplicationsListFilter'

const DLMSiteApplicationsListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-dlminspection-table-toolbar='base'>      
      <DLMSiteApplicationsListFilter />            
    </div>
  )
}

export {DLMSiteApplicationsListToolbar}
